import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { useT } from 'talkr';
import en from './i18n/en.json';
import Markdown from 'react-markdown';

type QuestionAndAnswer = {
    question: string;
    answer: string;
}

export default function FAQAccordion() {
  const {T} = useT();
  return (
    <>
      {Object.values(en.questionsAndAnswers).map(
        (_qa: QuestionAndAnswer, index: number) => (
          <Accordion
            key={index}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              border: "0px solid #cccc",
              mb: { xs: 1, sm: 1.5, md: 2 }, // Responsive margin between accordions
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              // expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ p: { xs: 0.5, sm: 1 } }} // Responsive padding
            >
              <Typography variant="h5" color="secondary.main" sx={{ fontSize: { xs: '1.125rem', sm: '1.25rem', md: '1.5rem' } }}>
                {T(`questionsAndAnswers.q${index + 1}.question`)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: { xs: 0.5, sm: 1 }, pt: 0 }}> {/* Responsive padding */}
              <Typography color="secondary.main" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
                <Markdown>
                  {T(`questionsAndAnswers.q${index + 1}.answer`)}
                </Markdown>
              </Typography>
            </AccordionDetails>
          </Accordion>
        )
      )}
    </>
  );
}
